<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.domain_application") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-3.col-2.mb-1(v-if="[5,4,3].includes(accountType)")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('ui.operator_id')" @enter="getDomainApplicationList(true)" size="sm")
              .form-group.col-md-3.col-2.mb-1(v-if="[5,4,3].includes(accountType)")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  DebounceInput(autofocus type="text" v-model="searchName" :placeholder="$t('ui.domain_name')" @enter="getDomainApplicationList(true)" size="sm")
              .form-group.col-md-3.col-2.mb-1(v-if="[5,4,3].includes(accountType)")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  b-form-select(v-model="searchStatus" size="sm" @change="getDomainApplicationList(true)")
                    option(value="") {{ $t('ui.all') }}
                    option(value="PENDING") {{ $t('ui.pending') }}
                    option(value="REJECTED") {{ $t('ui.rejected') }}
                    option(value="PROCESSED") {{ $t('ui.processed') }}
              .form-group.col-5.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getDomainApplicationList(true)"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isAdmin")
                template(v-if="isEditAccess")
                  b-button(v-b-modal.domainCustomAddAssign type="button" variant="info" size="sm")
                    i.fa.fa-plus
                    span.ml-1 {{ $t("ui.combine.domain_custom_add_assign") }}
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="5%")
                          span #
                        th(width="15%" @click="sortOrder('account_id')")
                          span(:ttile="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")
                        th.text-center(width="10%" @click="sortOrder('module')")
                          span(:title="$t('ui.module')") {{ $t("ui.module") }}
                          .float-right
                            i(:class="changeSortKey('module')")                        
                        th.text-center(width="10%" @click="sortOrder('status')")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                          .float-right
                            i(:class="changeSortKey('status')")
                        th(width="10%" @click="sortOrder('operator_id')")
                          span(:title="$t('ui.operator_id')") {{ $t("ui.operator_id") }}
                          .float-right
                            i(:class="changeSortKey('operator_id')")
                        th.text-left(width="15%")
                          span(:title="$t('ui.details')") {{ $t("ui.details") }}
                        th(width="15%")
                          span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                        th.text-right(width="10%" @click="sortOrder('created_date')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          i(:class="changeSortKey('created_date')")
                        th.text-right(width="10%")
                          span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                    tbody.clusterize-content
                      tr(v-if="domainList.length == 0")
                        td(colspan="10").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in domainList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.domain_name") {{ item.domain_name }} 
                        td.text-center
                          span(:title="item.module") {{ item.module }}                                                
                        td.text-center
                          template(v-if="item.status")
                            template(v-if="['PROCESSED','REJECTED'].includes(item.status.toUpperCase())")
                              span.d-block.font-weight-bold.mb-1(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status.toUpperCase() }}  
                            template(v-else)
                              span.d-block.font-weight-bold.mb-1(:class="$helpers.badgeClass(item.status)") {{ item.status.toUpperCase() }}
                        td
                          span(:title="item.operator_id") {{ item.operator_id }}
                        td.text-left
                          span.d-block {{ item.name_server }}
                          template(v-if="!isOperator")
                            span.d-block {{ item.server_account }}
                            span.d-block {{ item.service_provider }}
                        td
                          span(:title="item.remark") {{ item.remark }}    
                        td.text-right
                          span(:title="item.created_by") {{ item.created_by }}
                          br
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          span(:title="item.modified_by") {{ item.modified_by ? item.modified_by : "-" }}
                          br
                          span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ item.modified_date ? $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') : "-" }}
      domaincustomaddassign(ref="domaincustomaddassign" @clicked="afterDomainCustomAddAssign" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import domaincustomaddassign from "@/components/domain/domainCustomAddAssign.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    domaincustomaddassign
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },    
    currentPage: 1,
    totalRow: 0,
    domainList: [],
    searchName: "",
    searchID: "",
    searchStatus: "",
    selectedDomain: null,
    sortKey: "domain_name",
    sortType: "asc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_domainapplication");
    }
  },
  mounted: function() {
    this.getDomainApplicationList(true);
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getDomainApplicationList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getDomainApplicationList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getDomainApplicationList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    getDomainApplicationList: function(isSearch, evt) {
      let url = config.domainApplicationListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.searchName.trim() != '')
        json.domain_name = this.searchName;

      if (this.searchID.trim() != '') 
        json.operator_id = this.searchID;      

      if (this.searchStatus.trim() != '') 
        json.domain_status = this.searchStatus;
      
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.domainList = response.data.dt;
                this.totalRow = this.domainList.length > 0 ? this.domainList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    afterDomainCustomAddAssign: function() {
      this.searchName = "";
      this.searchID = "";
      this.searchStatus = "";
      this.getDomainApplicationList(true);

      this.$helpers.showDialog(this.$t("ui.combine.domain_custom_add_assign"), this.$t("message.success"), "success");
    }
  }
};
</script>